import { Component, OnInit } from '@angular/core';
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";

@Component({
  selector: 'app-actions-panel',
  templateUrl: './actions-panel.component.html',
  styles: []
})
export class ActionsPanelComponent implements OnInit {
    public onClose: Subject<any>;
    dagSourceModel: DagSourceModel;
    nodeOptions: INodeOptions;
    title: string;
    objectName: string;
    objectNameDisplayText: string;
    blocksList: any[] = [];
    constructor(
      public modalRef: BsModalRef,
    ) { }

    ngOnInit() {
        this.onClose = new Subject();
        this.blocksList = this.dagSourceModel.getBlocksSource().getBlockList(this.nodeOptions.workflowType, this.objectName);
    }

    onCloseModal() {
        this.onClose.next(true);
        this.modalRef.hide();
    }
}
